module.exports = __webpack_public_path__ + "img/chips.5a8e240b.png";